import { render } from "./ListePostPage.vue?vue&type=template&id=550c68da&ts=true"
import script from "./ListePostPage.vue?vue&type=script&lang=ts"
export * from "./ListePostPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__